const searchToggle = document.getElementById('desktop-search-toggle');
const preNavWrapper = document.getElementById('pre-nav-wrapper');

if(searchToggle && preNavWrapper) {
	searchToggle.addEventListener('click', function() {
		let ariaExpanded;
		preNavWrapper.classList.toggle('search-open');

		if(preNavWrapper.classList.contains('search-open')) {
			ariaExpanded = 'true';
		} else {
			ariaExpanded = 'false';
		}

		searchToggle.setAttribute('aria-expanded', ariaExpanded);
		toggleCartIconVisibility();
	});
}

function toggleCartIconVisibility() {
	const desktopCartWrapper = document.querySelector('.desktop-cart-wrapper');
	const topNav = document.getElementById('top-nav');

	if(!desktopCartWrapper || !topNav) {
		return;
	}

	const bsNavBreakpoint = topNav.getAttribute('bs-nav-breakpoint');

	if(bsNavBreakpoint) {
		desktopCartWrapper.classList.toggle(`d-${bsNavBreakpoint}-block`);
	}

}